import { useEffect, useState } from "react";

const isVisible = () => typeof document === "undefined" || document.visibilityState !== "hidden";

// True while the tab is in the foreground. Components use it to skip
// expensive, purely visual work while hidden (the browser can't paint it
// anyway) and to redo it in one go the moment the tab is shown again.
export function useTabVisible() {
    const [visible, setVisible] = useState(isVisible);

    useEffect(() => {
        const onChange = () => setVisible(isVisible());
        document.addEventListener("visibilitychange", onChange);
        return () => document.removeEventListener("visibilitychange", onChange);
    }, []);

    return visible;
}
